<template>
  <section>
    <b-table
      :data="conflictsData"
      :columns="conflictColumns"
      default-sort="shoppingCenterGroupName"
      default-sort-direction="asc"
      :row-class="() => 'is-danger'"

    ></b-table>
  </section>
</template>
<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import type { Section, Shop } from '@/stores/app';

interface ConflictRow {
  shoppingCenterGroupName: string | undefined;
  shoppingCenterName: string | undefined;
  shopName: string;
  sectionName: string | undefined;
  revenueValue: number | undefined;
  failureReason: string;
}

type ConflictShop = Shop & { sections?: Section[] };

export default defineComponent({
  props: {
    conflicts: {
      type: Array as PropType<ConflictShop[]>,
      default: () => [],
    },
  },
  data() {
    return {
      conflictColumns: [
        {
          field: 'shoppingCenterGroupName',
          label: this.$t('ShoppingCenterGroupName'),
          cellClass: 'has-text-right',
          sortable: true,
        },
        {
          field: 'shoppingCenterName',
          label: this.$t('ShoppingCenterName'),
          cellClass: 'has-text-right',
          sortable: true,
        },
        {
          field: 'shopName',
          label: this.$t('ShopName'),
          cellClass: 'has-text-right',
          sortable: true,
        },
        {
          field: 'sectionName',
          label: this.$t('SectionName'),
          cellClass: 'has-text-right',
          sortable: true,
        },
        {
          field: 'revenueValue',
          label: this.$t('Revenue'),
          cellClass: 'has-text-right',
          sortable: true,
        },
        {
          field: 'failureReason',
          label: this.$t('Reason'),
          cellClass: 'has-text-right',
          sortable: true,
        },
      ],
    };
  },
  computed: {
    conflictsData(): ConflictRow[] {
      return this.conflicts.flatMap((shop: ConflictShop) =>
        (shop.sections ?? [])
          .filter((section: Section) => section.updateSucceed === false)
          .map((shopSection: Section) => ({
            shoppingCenterGroupName: shop.shoppingCenterGroupName,
            shoppingCenterName: shop.shoppingCenterName,
            shopName: shop.shopName,
            sectionName: shopSection.sectionName,
            revenueValue: shopSection.revenueValue,
            failureReason: this.$t(shopSection.failureReason ?? '', {
              relatedFailureParameter: shopSection.relatedFailureParameter,
              identifierDescription:
                    `${shop.shoppingCenterName} - ${shop.shopName}`,
            }),
          }))
      );
    },
  },
});
</script>
<style lang="scss">
tr.is-danger {
        background: #FF5758;
        color: #fff;
    }
</style>
